
<template>
  <div class="tougao newsContent scrollView">
    <img :src="banner" class="zw_banner">
    <div class="zw_info">
      <div>活动简介：</div>
      <p>
<!--        《中小学生作文展播平台》是由成都电视台打造和运营，为学校或个人提供作文共享的专业平台。平台整合成都市中小学名校、成都市名作家、名师等教学资源，并为优秀人才、优秀作文提供展示舞台。平台还将以“作文交流活动、线下作文竞赛、名家线上互动、人才孵化机制”等手段，更好的传承国学文化。-->
<!--      -->
        由成都市文学艺术界联合会主办，中共成都市龙泉驿区委宣传部、成都市文艺发展服务中心(《青年作家》杂志社)、成都市作家协会、成都市龙泉驿区文学艺术界联合会承办，巴金文学院、成都经开文旅发展有限公司、成都春秋宇博文化投资管理有限公司协办的“2024第二届成都国际文学周暨第九届华语青年作家奖颁奖仪式”将于12月9日-12日在成都举行。作为文学周活动的重头戏，全民征文活动也正式启动。茅盾文学奖、鲁迅文学奖、“天问”华语科幻文学大赛奖、华语青年作家奖、杨升庵文学奖等获奖得主邀你一起书写不同人群视角下的成都故事。
      </p>
    </div>
    <div class="form-box">

      <van-form @submit="onSubmit">
        <van-field
                v-model="form.title"
                name="作文标题"
                label="作文标题"
                placeholder="请填写作文标题"
                :rules="[{ required: true}]"
        ></van-field>
        <van-field
                v-model="form.user"
                name="作者姓名"
                label="作者姓名"
                placeholder="请填写作者姓名"
                :rules="[{ required: true }]"
        ></van-field>
        <van-field
                v-model="form.school"
                name="作者学校(或单位)"
                label="作者学校(或单位)"
                placeholder="请填写作者学校(或单位)"
                :rules="[{ required: true }]"
        ></van-field>

        <van-field
                readonly
                clickable
                name="picker"
                :value="value"
                label="作者年级"
                placeholder="点击选择年级"
                @click="showPicker = true"
        ></van-field>
        <van-popup v-model="showPicker" position="bottom">
          <van-picker
                  show-toolbar
                  :columns="columns"
                  @confirm="onConfirm"
                  @cancel="showPicker = false"
          ></van-picker>
        </van-popup>



        <van-field
                readonly
                clickable
                name="picker"
                :value="leibieText"
                label="作文类型"
                placeholder="点击选择作文类型"
                @click="showPicker2 = true"
        ></van-field>
        <van-popup v-model="showPicker2" position="bottom">
          <van-picker
                  show-toolbar
                  :columns="leibie"
                  @confirm="onConfirm2"
                  @cancel="showPicker2 = false"
          ></van-picker>
        </van-popup>

        <van-field v-if="huodong_data && huodong_data.length>0"
                readonly
                clickable
                name="picker"
                :value="huodong"
                label="参与活动"
                placeholder="点击选择可参与的活动"
                @click="showHuodongPicker = true"
        ></van-field>
        <van-popup v-model="showHuodongPicker" position="bottom">
          <van-picker
                  show-toolbar
                  :columns="huodong_list"
                  @confirm="onConfirmHuodong"
                  @cancel="showHuodongPicker = false"
          ></van-picker>
        </van-popup>



        <van-field
                v-model="form.phone"
                name="联系方式"
                label="联系方式"
                placeholder="联系方式(必填)"
                :rules="[{ required: true}]"
        ></van-field>

        <div class="Editor-box">
          <Editor
                  style="height: 300px; overflow-y: scroll;"
                  v-model="html"
                  :defaultConfig="editorConfig"
                  :mode="mode"
                  @onCreated="onCreated"
          ></Editor>
        </div>



        <div style="padding-top: 20px">
          <div class="editor-addimg" @click="addimg()">
            <svg t="1596162017661" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2145"
                 xmlns:xlink="http://www.w3.org/1999/xlink" width="200" height="200">

              <path d="M867.90864 574.538232V257.779543a50.844091 50.844091 0 0 0-50.844092-50.844091h-610.129096a50.844091 50.844091 0 0 0-50.844092 50.844091v499.797418l430.141013-257.779543a152.532274 152.532274 0 0 1 157.108243 0z m0 118.466733l-177.445879-106.264151a50.844091 50.844091 0 0 0-50.844092 0L254.220457 817.064548h562.844091a50.844091 50.844091 0 0 0 50.844092-50.844091z m-660.973188-587.757696h610.129096a152.532274 152.532274 0 0 1 152.532274 152.532274v508.440914a152.532274 152.532274 0 0 1-152.532274 152.532274h-610.129096a152.532274 152.532274 0 0 1-152.532274-152.532274v-508.440914a152.532274 152.532274 0 0 1 152.532274-152.532274z m127.110228 355.90864a76.266137 76.266137 0 1 1 76.266137-76.266137 76.266137 76.266137 0 0 1-76.266137 76.266137z"
                    fill="#515151" p-id="2146"></path>
            </svg>
            <span>添加图片</span>
            <input type="file" id="file" style="display:none" @change="onFileChange($event)"/>
          </div>
        </div>

        <div style="margin: 16px;">
          <van-button round block type="info" native-type="submit">提交</van-button>
        </div>
      </van-form>

    </div>
    <div class="zw_info">
      <div>投稿要求：</div>
      <p>上传的作文必须为作者原创，题目自拟，文体不限。</p>
      <img src="../assets/zuowen_app_view.png" style="display: block; margin: auto; max-width: 80%">
    </div>

  </div>
</template>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style >
  .Editor-box{ padding:0 15px; overflow: hidden}
  .zw_banner{ width: 100%}
  .zw_info{ background-color: #fff; border-bottom: 5px solid #f4f5f7; padding: 15px; text-align: justify;line-height: 1.8}
  .zw_info div{ font-size: 16px;  color: #3e3e3e; padding-bottom: 5px}
  .zw_info p{ font-size: 12px; color: #7c7c7c}
  .form-box .van-cell{ box-sizing: border-box !important;}
  .Editor-box div{
    -webkit-user-select:text;
    outline: none;
  }


  .editor-addimg{ display: inline-block; width:60px; overflow: hidden; text-align: center}





  .editor-addimg img ,.editor-addimg svg{ height: 40px; display: block;width: 40px; margin: auto}

  .editor-addimg span{ font-size: 10px;color: #c9cacb }
  .editor-addimg.active svg path{ fill: #1989fa}
  .editor-addimg.active{ color: #1989fa}
</style>

<script>

// @ is an alias to /src
import { Editor } from '@wangeditor/editor-for-vue'
import request from "../utils/request";
import { Toast } from 'vant';
import utils from "../utils";
var $ = require("jquery");
export default {
  name: 'Home',
  data(){
    return{
      banner:"",
      show: false,
      showedireplay: false,
      //显示评论输入框

      form: {
        title:"",
        user:"",
        school:"",
        nianjie:"",
        phone:""

      },
      value: '',
      columns: [],
      showPicker: false,

      showloading: true,

      replayContent: '',
      //评论内容
      content_imgs: [],
      weather: false,
      textbarWidth:0,

      dafault_data: "<p style='color:#c5c6c7'>请输入作文内容</p><p></p><p></p><p></p>",
      clicked:false,
      editor: null,
      html: '',
      toolbarConfig: {},
      editorConfig: { placeholder: '请输入内容...' },
      mode: 'default', // or 'simple'
      isSubmiting:false,//是否提交中
      class_list:[],

      leibie:[],//作文类别
      leibieText:'',
      showPicker2:false,

      huodong:'',
      showHuodongPicker:false,
      huodong_list:[],//活动列表
      huodong_data:[]

    }
  },
  created() {
    this.zw_class_list();
    this.getZuowenBanner();
    if(utils.is_weixin()){
      request.getWeixinShanre(location.href,(s_res)=>{
        let {appId,timestamp,nonceStr,signature,thumb} = s_res.data;
        let shareconfig = {appId,timestamp,nonceStr,signature};

          let sharedata = {
            title:"看度时政-作文投稿入口",
            desc:"看度时政作文投稿入口，更多精彩请下载看度时政APP",
            link:location.href,
            imgUrl:thumb
          };
          utils.setWeiXinShare(sharedata,shareconfig,false)
      });
    }

  },
  methods:{
    getZuowenBanner(){
      request.zuowenBanner(res=>{
        console.log(res)
        if(res && res.code==200 && res.data && res.data.zuowen_banner_web){
          this.banner = res.data.zuowen_banner_web
        }else{
          // this.banner = require("../assets/zuowen_banner2.png")
        }

      })
    },
    addimg(){
      document.getElementById("file").click()

    },
    onFileChange(e){
      try{
        Toast.loading({
          message: '上传中...',
          forbidClick: true,
          duration:0
        });
        if(e.target.files && e.target.files.length>0){
            var files= e.target.files[0]
          console.log(files)
          // alert(JSON.stringify(files.name))

          var data = new FormData();
          data.append('file', files);
          var _this = this;
          request.uploadFile(data,(res)=>{
            Toast.clear()
            console.log(res)
            if(res.message){
              // alert(res.message)
              Toast(res.message);
            }

            var html = this.editor.getHtml() +'<p><br><img src="' + res.data + '"> </p>';
            this.editor.setHtml(html)
            //this.editor.dangerouslyInsertHtml('<p><br><img src="' + res.data + '"> </p>')
          })
          // $.ajax({
          //   method:'POST',
          //   url:'http://www.liulongbin.top:3006/api/upload/avatar',
          //   data:data,
          //   // 不对FromData中的url进行编码，原样发送
          //   processData:false,
          //   // 不修改contentType属性，使用默认
          //   contentType:false,
          //   success: function(res) {
          //     console.log(res)
          //     Toast.clear()
          //     // 将图片文件显示在网页中
          //     res.data = 'http://192.168.3.188:8080/img/zw_banner.b460ff91.png'
          //     _this.editor.dangerouslyInsertHtml('<p><br><img src="' + ret.data + '"> </p>')
          //   }
          // })


        }else{
          Toast.clear()
          Toast('请选择文件');
        }
      }catch(e){
        console.log(e)
        Toast.clear()
        Toast('上传出错');
      }

    },
    onCreated(editor) {
      this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错

    },
    zw_class_list:function(){
      var _this = this;
      request.zw_class_list(function(res){
        if(res && res.code===200){
          _this.class_list = res.data;
          _this.leibie = res.data2;
          var name = [];
          var ids = [];
          for(var i = 0;i<res.data.length;i++){
            name.push(res.data[i].cat_name);
            ids.push(res.data[i].id)
          }
          _this.columns = name;
          _this.ids = ids

          if(res.data3){
            name = [];
            ids = [];
            for(var i = 0;i<res.data3.length;i++){
              name.push(res.data3[i].ac_name);
              ids.push(res.data3[i].ac_id)
            }
            _this.huodong_list = name;
            _this.huodong_data = res.data3
          }
        }else{
          alert("获取年级列表失败")
          setTimeout(function () {
            _this.zw_class_list()
          },1500)
        }
      })
    },
    onSubmit(){

      if(this.isSubmiting ){
        return
      }

      var cat_id = 0;
      for(var i =0;i<this.class_list.length;i++){
        if(this.class_list[i].cat_name === this.value){
          cat_id = this.class_list[i].id
        }
      }
      if(!cat_id){
        alert("获取年级失败！请稍后再试");
        return
      }

      this.isSubmiting = true;



      var content = this.editor.getHtml();
      var postData = {
        zuowen_type:this.leibieText,
        title:this.form.title,
        author:this.form.user,
        reprint:this.form.school,
        cat_id:cat_id,
        content:content,
        contact_us:this.form.phone,
        source:"web",

      }
      if(this.huodong){
        for(var i =0;i<this.huodong_data.length;i++){
          if(this.huodong_data[i].ac_name === this.huodong){
            postData.ac_id = this.huodong_data[i].ac_id
          }
        }
      }


      var _this = this;
      request.zw_tougao(postData,function(res){

        if(res && res.code===200){

          alert("提交成功,审核通过后将展示！");
          setTimeout(function(){
            location.reload();
          },1500)
          _this.isSubmiting = true
        }else if(res && res.message){
          alert(res.message)
          _this.isSubmiting = false;

        }else{
          alert("提交失败")
          _this.isSubmiting = false
        }
      })




    },
    //选择类别
    onConfirm2(val){

      this.leibieText = val;
      this.showPicker2 = false;
    },
    onConfirm(value) {
      this.value = value;
      this.showPicker = false;
    },
    //活动
    onConfirmHuodong(value) {
      this.huodong = value;
      this.showHuodongPicker = false;


    },
  },
  components: {
    Editor
  }
}
</script>
